import React, { useState, useEffect } from "react";
import LanguageButtons from "./LanguageButtons";
import { useTranslation } from "react-i18next";

type InputOnChangeEvent =
  React.InputHTMLAttributes<HTMLInputElement>["onChange"];

const LanguageSelector: React.FC<{}> = () => {
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState("ja");

  const languageChange: InputOnChangeEvent = (e) => {
    const _lang = e.target.value === "en" ? "en" : "ja";
    localStorage.setItem("language", _lang);
    setSelectedLanguage(_lang);
    i18n.changeLanguage(_lang);
  };

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
  }, [i18n]);

  return (
    <LanguageButtons
      language={selectedLanguage}
      languageChange={languageChange}
    />
  );
};
export default LanguageSelector;
